import React, { Ref, forwardRef } from 'react';
import css from './InputText.module.css';

export interface InputTextProps {
  type: 'text' | 'number' | 'password';
  inputMode: 'text' | 'numeric' | 'tel';
  placeholder?: string;
  disabled?: boolean;
  onFocus: () => void;
  onBlur: () => void;
  onChange: (value: string) => void;
  value: string;
}

const InputTextComponent: React.ForwardRefRenderFunction<
  HTMLInputElement,
  InputTextProps
> = (props: InputTextProps, ref: Ref<HTMLInputElement>) => {
  const { disabled = false } = props;
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(event.target.value);
  };

  return (
    <input
      ref={ref}
      type={props.type}
      value={props.value === null ? '' : props.value}
      disabled={disabled}
      className={css.textInput}
      inputMode={props.inputMode}
      placeholder={props.placeholder}
      autoCapitalize="off"
      autoComplete="off"
      onChange={onChange}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
    />
  );
};

const InputText = forwardRef(InputTextComponent);

export default InputText;
